(function () {
    const cep = $(".searchcep");
    if (cep.attr("readonly") != null) {
        return;
    }

    cep.focusout(function () {

        if ($(this).val().length == 9) {
            $.ajax({
                url: URL("api/v1/tools/cep?cep=" + $(this).val()),
                type: 'get',
                beforeSend: function () {
                    $(".loading").show();
                },
                success: function (result) {
                    $(".streetsearch").val(result.street);
                    $(".statesearch").attr("city_select", result.city_id);
                    $(".statesearch").val(result.state_id);
                    $(".statesearch").change();
                    $(".citysearch").attr('disabled', null);

                    $(".citysearch").empty() //empty select
                        .append($("<option/>") //add option tag in select
                            .val(result.city_id) //set value for option to post it
                            .text(result.city_name)) //set a text for show in select
                        .val(result.city_id) //select option of select2
                        .trigger("change");
                    $(".loading").hide();
                },
                error: function (err) {
                    console.log(err);
                    $(".loading").hide();
                }
            });
        }
    });
})();
function URL(urlpath) {
    let url = "";
    url += window.location.protocol + "//";
    url += window.location.hostname;
    const porta = window.location.href
        .replace(window.location.protocol + "//", '')
        .replace(window.location.pathname, '')
        .replace(window.location.hostname, '')
        .replace(":", "");

    if (!isNaN(porta)) {
        url += ":" + porta;
    }
    if (urlpath.charAt(0) == '/') {
        return url + urlpath;
    } else {
        return url + "/" + urlpath;
    }
}
